import React from 'react';
import './FormTitle.css';

/**
 * FormTitle Component
 * Main form heading (h1/h2)
 * 
 * @param {string} text - Title text
 * @param {number} level - Heading level: 1 | 2 (default: 1)
 * @param {string} className - Additional CSS classes
 */
const FormTitle = ({
  text,
  level = 1,
  className = ''
}) => {
  const HeadingTag = level === 1 ? 'h1' : 'h2';
  const levelClass = `form-title-level-${level}`;

  return (
    <HeadingTag className={`form-title ${levelClass} ${className}`.trim()}>
      {text}
    </HeadingTag>
  );
};

export default FormTitle;










